import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";
import { useSearch } from "../SearchBar/SearchContext";
import SearchBar from "../SearchBar/SearchBar";
import { FaInstagram } from "react-icons/fa";
import BurgerMenu from "../BurgerMenu/BurgerMenu";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";
import "./css/header.scss";

function Header() {
  const { translations } = useLanguage();
  const { searchData } = useSearch();
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isLangOpen, setIsLangOpen] = useState(false);

  const closeAll = () => {
    setIsSearchOpen(false);
    setIsLangOpen(false);
  };

  return (
    <div className="header">
      <div className="header__container container">
        <BurgerMenu />
        <ul className="header__navbar">
          <li>
            <NavLink
              to="/"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              {translations.header.home}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/polish-culture"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              {translations.header.polishCulture}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/legendary-stories"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              {translations.header.legendaryStories}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/for-foreigners"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              {translations.header.forForeigners}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/about-me"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              {translations.header.aboutMe}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/contact"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              {translations.header.contact}
            </NavLink>
          </li>
        </ul>
        <div className="header__contact">
          <NavLink
            to="https://www.instagram.com/madeinpolsce/profilecard/?igsh=MXJnOTA2YjM1dm84eQ=="
            className="instagram-icon"
          >
            <FaInstagram />
          </NavLink>
          <SearchBar
            isOpen={isSearchOpen}
            onOpen={() => {
              closeAll();
              setIsSearchOpen(true);
            }}
            onClose={() => setIsSearchOpen(false)}
          />
          <LanguageSwitcher
            isOpen={isLangOpen}
            onOpen={() => {
              closeAll();
              setIsLangOpen(true);
            }}
            onClose={() => setIsLangOpen(false)}
          />
        </div>
      </div>
    </div>
  );
}

export default Header;
